module.exports = __webpack_public_path__ + "static/media/Board of Studies_2021-22.1c6c4c9a.pdf";